import React, { useState, useEffect, useRef, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { ASSETS_URL, store } from "../../../Store";

import { useGeneralHeaderDropdown } from "../../../../hooks/header/useGeneralHeaderDropdown";

import { DropdownMiCuenta } from "./DropdownMiCuenta";
import { SearchBooksButton } from "./search-books-button";
import { HGResourcesButton } from "../../components/button-resources/hg-resources-button";

/**
 * Componente con las opciones del header general
 * @param {object} textosInterfaz - contiene los textos de interfaz
 * @returns {JSX.Element} NavbarNav
 */
export const NavbarNav = ({ textosInterfaz }) => {

    const globalState = useContext(store);
    const { state } = globalState;
    const isLogged = state.sesionActiva !== null && state.sesionActiva === "SI";

    const showADropdown = useGeneralHeaderDropdown();
    const visible = showADropdown?.state?.visible;
    const dropdownButtonRef = useRef(null);
    const dropdown = useRef(null);

    const location = useLocation();
    const isPersonalAccount = state?.isPersonalAccount;
    const accountLabel = !isPersonalAccount
        ? textosInterfaz?.mi_cuenta || "Mi cuenta"
        : textosInterfaz?.mi_perfil || "Mi perfil";

    const isActiveRoute =
        location.pathname.includes("/ayuda") ||
        location.pathname.includes("/mi-panel") ||
        location.pathname === "/descargados" ||
        location.pathname === "/favoritos";

    const avatar = isLogged && state.datosHeader?.avatar
        ? `${ASSETS_URL}${state.datosHeader.avatar}`
        : "/img/profile.png";

    /*cierra el dropdown al hacer scroll al inicio de la página */
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY >= 1 && window.scrollY < 10) {
                showADropdown.setVisible(false);
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [showADropdown]);

    useEffect(() => {
        if (!dropdownButtonRef.current) {
            return;
        }

        globalState.dispatch({
            type: "CHANGE",
            path: "generalHeaderDropdown.triggerButtonRef",
            value: dropdownButtonRef,
        });
    }, [globalState.dispatch]);

    return (
        <ul className="option-nav d-flex" role="list">
            <li>
                <SearchBooksButton />
            </li>

            <li>
                <Link
                    className={`
                        ml-4
                        focusable-red
                        d-flex
                        justify-content-center
                        align-items-center
                        body-m
                        btn-header-general
                        ${location.pathname === '/comunidad' ? "activeMode" : ""}
                    `}
                    to={"/comunidad"}
                >
                    {textosInterfaz?.comunidad || 'Comunidad'}
                    <i
                    className={`fas fa-chevron-down fa-sm ml-2 arrow d-none d-lg-block`}
                    aria-hidden={true}
                />
                </Link>
            </li>

            <li className="mr-auto">
                <HGResourcesButton />
            </li>

            <li className="relative">
                <button
                    ref={dropdownButtonRef}
                    className={`
                        focusable-red
                        d-flex
                        justify-content-center
                        align-items-center
                        btn-header-general
                        ${visible ? "openMode" : ""}
                        ${isActiveRoute ? "activeMode" : ""}
                    `}
                    onClick={() => {
                        showADropdown.setVisible(!visible);
                    }}
                    aria-label={textosInterfaz?.button_account_description || "Abrir la lista desplegable de páginas pertenecientes a mi cuenta"}
                >
                    <div
                        className="mr-1 btn-avatar"
                        style={{
                            backgroundImage: `url('${avatar}')`,
                        }}
                    ></div>
                    <span className="una-linea-texto">{accountLabel}</span>
                    <i className={`fas fa-chevron-down fa-sm ml-2 arrow d-none d-lg-block ${visible && "active-arrow"}`} aria-hidden={true}></i>
                </button>
                <DropdownMiCuenta textosInterfaz={textosInterfaz} />
            </li>


        </ul>
    )
}